import axios from 'axios';
import { AuthType, createAuthenticationInterceptor } from '@dtvgo/axios-interceptor-auth';
import { createClientHeadersInterceptor } from '@dtvgo/axios-interceptor-client-headers';
import { retryRefreshToken } from '@dtvgo/axios-interceptor-retry-auth';

function createToolboxService({
  host,
  deviceId,
  clientHeadersOptions,
  region,
  tokens
}) {
  const axiosInstance = axios.create({
    baseURL: host,
    timeout: 6e4,
    headers: {
      "Content-Type": "application/json",
      "x-device-id": deviceId,
      "x-client-type": "web"
    }
  });
  const clientHeadersInterceptor = createClientHeadersInterceptor(clientHeadersOptions);
  axiosInstance.interceptors.request.use(clientHeadersInterceptor);
  const getRegion = typeof region === "function" ? region : () => region;
  return {
    axiosInstance,
    v3: {
      login: async (username, password, recapchaToken) => axiosInstance.post(
        "/v3/oauth2/token",
        {
          username,
          password,
          region: await getRegion(),
          grantType: "password",
          "g-recaptcha-response": recapchaToken
        }
      ),
      partnerLogin: (code) => axiosInstance.post(
        "/v3/oauth2/token",
        {
          code,
          grantType: "authorizationCode"
        }
      ),
      refreshToken: async (refreshToken, { businessUnit, msoProvider }) => retryRefreshToken(
        axiosInstance,
        refreshToken,
        businessUnit,
        msoProvider,
        getRegion,
        tokens
      )
    }
  };
}
function createToolboxTvService({
  host,
  auth,
  deviceId,
  clientHeadersOptions,
  region,
  tokens,
  authInterceptor,
  authorization
}) {
  const axiosInstance = axios.create({
    baseURL: host,
    auth,
    headers: {
      Authorization: `Basic ${authorization}`,
      "Content-Type": "application/json",
      "x-device-id": deviceId
    }
  });
  const clientHeadersInterceptor = createClientHeadersInterceptor(clientHeadersOptions);
  const authenticationInterceptor = async (requestConfig) => {
    const { access_token: ssoToken } = await tokens.get();
    const interceptor = createAuthenticationInterceptor({ options: { ssoToken } });
    return interceptor(requestConfig);
  };
  axiosInstance.interceptors.request.use(clientHeadersInterceptor);
  axiosInstance.interceptors.request.use(authenticationInterceptor);
  const getRegion = typeof region === "function" ? region : () => region;
  if (authInterceptor) {
    axiosInstance.interceptors.response.use(void 0, authInterceptor);
  }
  return {
    axiosInstance,
    v2: {
      tv: {
        getDeviceCode: async () => axiosInstance.post(
          "/v2/tv/device/code",
          {
            responseType: "deviceCode",
            region: await getRegion()
          }
        ),
        loginDevice: (deviceCode) => axiosInstance.post(
          "/v2/oauth2/token",
          {
            grantType: "deviceToken",
            code: deviceCode
          }
        ),
        activateDevice: (userCode, internalSsoToken) => axiosInstance.post(
          "/v2/tv/activation",
          {
            userCode
          },
          {
            authentication: {
              type: AuthType.SSO_TOKEN,
              options: { ssoToken: internalSsoToken }
            }
          }
        ),
        refreshToken: async (refreshToken, { businessUnit, msoProvider }) => retryRefreshToken(
          axiosInstance,
          refreshToken,
          businessUnit,
          msoProvider,
          getRegion,
          tokens
        )
      }
    }
  };
}

export { createToolboxService, createToolboxTvService };
//# sourceMappingURL=createService.js.map
